import fetch from "auth/FetchInterceptor";

const VacancySlice = {};

VacancySlice.GetVacanciesSSSR = async function (data) {
  return fetch({
    url: "/JobOpening/GetAllSSR",
    method: "post",
    data: data,
  });
};
VacancySlice.CreateVaccancies = async function (data) {
  return fetch({
    url: "/JobOpening/Create",
    method: "post",
    data: data,
  });
};
VacancySlice.UpdateVaccancies = async function (data) {
  return fetch({
    url: "/JobOpening/Update",
    method: "post",
    data: data,
  });
};
VacancySlice.GetVacancyById = async function (params) {
  return fetch({
    url: "/JobOpening/GetById",
    method: "get",
    params,
  });
};
VacancySlice.GetVacancyStatus = async function () {
  return fetch({
    url: "/JobOpening/GetJobOpeningStatus",
    method: "get",
  });
};
VacancySlice.SetActive = async function (params) {
  return fetch({
    url: "/JobOpening/SetIsActive",
    method: "get",
    params,
  });
};
VacancySlice.GetAllVacancy = async function () {
  return fetch({
    url: "/JobOpening/GetVacancies",
    method: "get",
  });
};
VacancySlice.SetPublic = async function (params) {
  return fetch({
    url: "/JobOpening/SetPublic",
    method: "get",
    params,
  });
};

export default VacancySlice;
